
import React from "react";
import * as react from "react";
import { map } from "../../../fable_modules/fable-library-js.5.0.0/Option.js";
import { FSharpMap__TryFind } from "../../../fable_modules/fable-library-js.5.0.0/Map.js";
import { LoadingScreen } from "@stenajs-webui/panels";

export function LoadingScreenModule_View($props) {
    const p = $props.p;
    const props = {
        text: map((x) => x, FSharpMap__TryFind(p, "text")),
    };
    return react.createElement(LoadingScreen, props);
}

